import MobileDetect from 'mobile-detect';
import { randomUUID } from 'cfmoto-utils';

export { default as JSONSort } from './JSONSort';
export { default as launchApplicationMarket } from './launchApplicationMarket';
export { default as linearInterpolate } from './linearInterpolate';

export function uuid() {
  const tempUrl = URL.createObjectURL(new Blob());
  const uuid0 = tempUrl.toString();
  URL.revokeObjectURL(tempUrl); // 释放这个url
  return uuid0.substring(uuid0.lastIndexOf('/') + 1);
}

// 版本号比较
export function compareVersions(v1, v2) {
  if (!v1 && !v2) return 0;
  if (!v1) return -1;
  if (v1 && !v2) return 1;
  const parts1 = v1.split(/[.-]/);
  const parts2 = v2.split(/[.-]/);

  const len = Math.max(parts1.length, parts2.length);

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(parts1[i] || 0, 10);
    const num2 = parseInt(parts2[i] || 0, 10);

    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }

  return 0;
}

export function getVideoSnapshot(src, v = new Date().getTime()) {
  if (!src || /(jpg|png|gif|jpeg)$/.test(src)) return src || '';
  const backgroundImageUrl = /^http/.test(src) ? `${src.split('?')[0]}?x-oss-process=video/snapshot,t_1000,w_800,f_png,m_fast&v=${v}` : src;
  console.log(backgroundImageUrl);
  return backgroundImageUrl;
}

export function formatterDateText($datetime) {
  if (!$datetime) return '';
  const datetime = $datetime.split('.')[0].split('-').join('/');
  const preTime = new Date(datetime).getTime() / 1000 / 60;
  const nowTime = new Date().getTime() / 1000 / 60;

  if (nowTime - preTime < 1) {
    return '刚刚';
  }
  if (nowTime - preTime < 60) {
    return `${parseInt(nowTime - preTime, 10)}分钟前`;
  }
  if (nowTime - preTime > 60 && nowTime - preTime < 24 * 60) {
    return `${parseInt((nowTime - preTime) / 60, 10)}小时前`;
  }
  if (nowTime - preTime > 24 * 60) {
    console.log(new Date(datetime).getFullYear);
    return `${new Date(datetime).getFullYear()}.${new Date(datetime).getMonth() + 1}.${new Date(datetime).getDate()}`;
  }
  return '';
}

export function formatterCitys(citys) {
  const tempData = JSON.parse(JSON.stringify(citys));
  const areaList = {
    province_list: {},
    city_list: {},
    county_list: {},
  };
  tempData.forEach((item) => {
    areaList.province_list[item.code] = item.codeName;
    item.cityCodeVOList.forEach((ite) => {
      if (ite.code == '810000' || ite.code == '820000') {
        ite.code = ite.code.slice(0, 2) + '01' + ite.code.slice(4);
        console.log(ite.code);
        areaList.city_list[ite.code] = ite.codeName;
        ite.cityCodeVOList.forEach((it) => {
          it.code = it.code.slice(0, 2) + '01' + it.code.slice(4);
          areaList.county_list[it.code] = it.codeName;
        });
      } else {
        areaList.city_list[ite.code] = ite.codeName;
        ite.cityCodeVOList.forEach((it) => {
          areaList.county_list[it.code] = it.codeName;
        });
      }
    });
  });
  return areaList;
}

export function getCustomAgent() {
  function isHarmonyNext() {
    const ua1 = (navigator.userAgent.toLowerCase().match(/openharmony/i) && true) || false;
    const ua2 = (navigator.userAgent.toLowerCase().match(/arkweb/i) && true) || false;
    return ua1 || ua2;
  }
  if (!window.navigator.customAgent) {
    // window.navigator.customAgent = 'Mozilla/5.0 (iPhone; CPU iPhone OS 18_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 zeeho/2.1.3 (iPhone 11 Build/18.1.1)';
    window.navigator.customAgent = window.navigator.userAgent;
  }
  const userAgent = window.navigator.customAgent;
  const md = new MobileDetect(userAgent);

  // const appType = this.isAndroid ? 'Android' : 'IOS';
  const appVersion = (/(zeeho|Zeeho)\/([\d]+\.[\d]+\.[\d]+)/.exec(userAgent) || [])[2];
  const harmonySystemVersion = ((/OpenHarmony [\\.\d]+/.exec(userAgent) || [])[0] || '').split(' ')[1] || '';
  const systemName = /OpenHarmony/.test(userAgent) ? 'Harmony' : md.os();
  const systemVersionStr = md.versionStr(md.os()) || md.versionStr('Android') || md.versionStr('iOS') || harmonySystemVersion;
  const systemVersion = `${systemName} ${systemVersionStr}`.replace(/_/g, '.').split(' ')[1];
  const phoneModel = (/\(([^\\(]+) (Build\/[\\.\d]+\))/.exec(userAgent) || [])[1] || 'unknown';
  // const phoneModel = ((/(Mobile\/[\w]+)/.exec(userAgent) || [])[1] || 'Build/unknown').replace('Mobile', `Build`);
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const screenSize = `${screenWidth}*${screenHeight}`;
  console.log(md);
  console.log(phoneModel, systemVersion, harmonySystemVersion);

  console.log(window.navigator.userAgent); // 'Sony'
  console.log(md.mobile()); // 'Sony'
  console.log(md.phone()); // 'Sony'
  console.log(md.mobileGrade()); // 'Sony'
  console.log(md.tablet()); // null
  console.log(md.userAgent()); // 'Safari'
  console.log(md.os()); // 'AndroidOS'
  console.log(md.is('iPhone')); // false
  console.log(md.is('iPhone')); // false
  console.log(md.version('Webkit')); // 534.3
  console.log(md.versionStr(md.os()) || md.versionStr('Android') || md.versionStr('iOS')); // '4.1.A.0.562'
  console.log(md.match('playstation|xbox')); // false
  console.log('==== appVersion ====');
  console.log((/(zeeho|Zeeho)\/([\d]+\.[\d]+\.[\d]+)/.exec(userAgent) || [])[2]);
  console.log('==== model ====');
  console.log((/\(([^\\(]+) (Build\/[\\.\d]+\))/.exec(userAgent) || [])[1] || 'unknown');
  const networkType = !navigator.connection ? 'unknown' : navigator.connection.effectiveType || 'unknown';
  if (/ios/.test((md.os() || '').toLocaleLowerCase())) {
    return `MOBILE|${md.os()}|${systemVersion}|ZEEHO_APP|${appVersion}|iPhone|${phoneModel}|${screenSize}|${randomUUID().toUpperCase()}|${networkType}|iOS`;
  }
  // Mozilla/5.0 (iPhone; CPU iPhone OS 18_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 zeeho/2.1.3 (iPhone 11 Build/18.1.1)
  // return 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.131 Safari/537.36';
  // MOBILE|Android|7.1.1|KLICEN_APP|4.0.10|Dalvik/2.1.0 (Linux; U; Android 7.1.1; OD103 Build/NMF26F)|1080*1920|ccf8ba18defca0f6|100
  // MOBILE|iOS|26.0|ZEEHO_APP|2.6.0|iPhone|iPhone16|1179*2556|C73B0832-CAE8-4522-B06A-D8F2B1452C95|WiFi|iOS
  if (isHarmonyNext()) {
    return `MOBILE|Harmony|${systemVersion}|ZEEHO_APP|${appVersion}|Huawei|${phoneModel}|${screenSize}|${randomUUID()}|${networkType}|${md.os()}`;
    // return `MOBILE|Harmony|${systemVersion}|ZEEHO_APP|${appVersion}|iPhone|iPhone|${screenSize}|${randomUUID().toUpperCase()}|${networkType}|iOS`;
  }
  return `MOBILE|Android|${systemVersion}|ZEEHO_APP|${appVersion}|${phoneModel}|${screenSize}|${randomUUID()}|${networkType}|${md.os()}`;
  // return `MOBILE|Android|${systemVersion}|ZEEHO_APP|${appVersion}|Dalvik/2.1.0 (Linux; U; Android ${systemVersion}; OD103 Build/${phoneModel})|${phoneModel}|${screenSize}|${randomUUID()}|${networkType}|${md.os()}`;

  // return `MOBILE|Android|${systemVersion}|ZEEHO_APP|${appVersion}|Dalvik/2.1.0 (Linux; U; Android ${systemVersion}; OD103 Build/${phoneModel})|${screenSize}|${randomUUID()}|100`;
}

export default { uuid };
